// removed by extract-text-webpack-plugin
module.exports = {"flexPrev":"_3b4d7Ljm3z5nyw0A24yj8h","flexNext":"_1fTlwW4FJb-nSpD1avpM2X","carousel":"ZxiJE34AnSl_HEKKTh83Q","dotsClass":"_3vh9oAzYYLOre-BI4BATTr","slick-active":"_3EGZTB-qNmRyM-7G9Q5Q6R","childItem":"_3eMUmaSIGoUlK71H88FzII","img":"gv3IIhGQaOBcb62l1FwnE","bottomLink":"_3sE5WrcN0Q1Htg8JjWgSlU","link":"_323Qkhz-y5YQuy3X4RYWy9"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CarouselOfDetailWithLink/CarouselOfDetailWithLink.scss
 ** module id = 256
 ** module chunks = 0
 **/